import { constantRouterMap, routerMap } from '@/router'
import { bussinessTree } from '@/api/login'
import Layout from '@/views/layout/Layout'
import store from '@/store'

const iconsMap = {
  conferencebooking: 'mdi:message-text-clock',
  conferenceStatus: 'fluent-mdl2:temporary-user',
  myTaskList: 'icon-park-outline:list-numbers',
  meetingSet: 'material-symbols:settings-suggest-outline-sharp',
  mettingManagement: 'ic:round-manage-history',
  departmentManage: 'material-symbols:lock-person-outline',
  count: 'material-symbols:bar-chart-rounded',
  morningMeeting: 'ri:file-user-line'
}
// 根据数据装载成路由格式
function formatRoutes(aMenu) {
  const aRouter = []
  const language = store.getters.language
  for (const i in aMenu) {
    const childrenMenu = aMenu[i].childUserRight
    let routerItem = {}
    const childRoute = []
    for (const j in childrenMenu) {
      let route = {}
      if (childrenMenu.length > 1) {
        routerItem = {
          path: `/${aMenu[i].umUrl.split('/')[1]}`,
          component: Layout,
          redirect: aMenu[i].umUrl,
          alwaysShow: true,
          meta: {
            title: language === 'zh' ? aMenu[i].umTitle : aMenu[i].umEnTitle,
            icon: iconsMap[aMenu[i].umUrl.split('/')[1]]
          }
        }
        route = {
          path: `${childrenMenu[j].urUrl}/index`,
          component: routerMap[childrenMenu[j].urUrl.split('/')[1]],
          // name: childrenMenu[j].urEnName,
          meta: {
            title: language === 'zh' ? childrenMenu[j].urName : childrenMenu[j].urEnName,
            icon: ''
          }
        }
      } else {
        routerItem = {
          path: `${childrenMenu[j].urUrl}`,
          component: Layout,
          redirect: `${childrenMenu[j].urUrl}/index`
        }
        route = {
          path: `index`,
          component: routerMap[childrenMenu[j].urUrl.split('/')[1]],
          // name: childrenMenu[j].urEnName,
          meta: {
            title: language === 'zh' ? childrenMenu[j].urName : childrenMenu[j].urEnName,
            icon: iconsMap[childrenMenu[j].urUrl.split('/')[1]]
          }
        }
      }
      childRoute.push(route)
      routerItem.children = childRoute
    }
    aRouter.push(routerItem)
  }
  return aRouter
}

const permission = {
  state: {
    routers: [],
    addRouters: []
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers
      state.routers = constantRouterMap.concat(routers)
    }
  },
  actions: {
    GenerateRoutes({ commit }) {
      return new Promise((resolve, reject) => {
        bussinessTree(store.getters.systemCode).then(response => {
          const router = formatRoutes(response.data)
          const accessedRouters = router
          commit('SET_ROUTERS', accessedRouters)
          resolve()
        })
          .catch(error => {
            console.log(error)
            reject(error)
          })

        // commit('SET_ROUTERS', asyncRouterMap)
        // resolve()
      })
    }
  }
}
export default permission
